import React, {Component} from 'react';

export default class Influence extends Component{
    render(){

        return (
            <div>{this.props.children}</div>
        )
    }
}
